module.exports = __webpack_public_path__ + "img/ADS.3869559b.svg";